export function isRequiredSchema(schema) {
  const {
    required
  } = schema;
  const isRequired = required === true || required === undefined || required === null;
  return isRequired;
}
//# sourceMappingURL=isRequiredSchema.js.map
